import { resolveRuntimeOrigin } from '../lib/runtimeEnv';

// Builds a preview-safe redirect back to this origin.
export function getRedirectTo(returnPath?: string | null): string {
  const origin = resolveRuntimeOrigin();
  const base = `${origin ?? ''}/auth/callback`;
  if (!returnPath) return base;
  const query = new URLSearchParams({ from: returnPath });
  return `${base}?${query.toString()}`;
}
